/* eslint-disable i18next/no-literal-string -- TanStack cache key segments */
/**
 * `entities/project-file` TanStack Query key factory.
 *
 * Tuple shapes are INLINED to match the historical `PROJECTS_QUERY_KEYS.files.*`
 * factory in `entities/project/api/query-keys.ts` byte-for-byte. See the same
 * decision recorded in `entities/project-folder/api/query-keys.ts`:
 * cross-entity value imports are forbidden inside `src/entities/**`, so each
 * new entity inlines the relevant tuples and pins them with a cache-contract
 * snapshot test.
 *
 */

export const PROJECT_FILE_QUERY_KEYS = {
  /** Prefix covering every file's detail in a project, for changes that move many at once. */
  details: (projectId: string) => ['project', projectId, 'files', 'detail'] as const,

  /** Single file by id. */
  detail: (projectId: string, fileId: string) =>
    ['project', projectId, 'files', 'detail', fileId] as const,

  /**
   * Versions of a specific file. Documented quirk preserved: `fileId` slot
   * lands BEFORE the `'versions'` tag (matches the legacy factory).
   */
  versions: (projectId: string, fileId: string) =>
    ['project', projectId, 'files', fileId, 'versions'] as const,
} as const;
